function base64UrlToString(token: string): string | null {
    try {
        const b64 = token.replace(/-/g, "+").replace(/_/g, "/");
        const pad = b64.length % 4 === 0
            ? ""
            : "=".repeat(4 - (b64.length % 4));
        const decoded = atob(b64 + pad);

        try {
            const bytes = Uint8Array.from(decoded, (c) => c.charCodeAt(0));
            return new TextDecoder("utf-8").decode(bytes);
        } catch {
            return decoded;
        }
    } catch {
        return null;
    }
}

export function extractNicknameFromSlug(
    slug: string | undefined | null,
): string {
    if (!slug) return "there";

    const parts = slug.split("-").filter(Boolean);
    const token = parts[parts.length - 1] ?? "";

    const maybeB64 = base64UrlToString(token);
    const raw = (maybeB64 ?? token).trim();

    let cleaned = raw;
    try {
        cleaned = decodeURIComponent(raw);
    } catch {
        // ignore
    }

    const nick = cleaned.replace(/\s+/g, " ").trim();
    return nick.length ? nick.slice(0, 40) : "there";
}
